<template>
	<div id="content">
		<span id="inner" v-if="setting">
			<input
				v-model="new_name"
				style="margin: 0 10px 0 0; width: auto;"
				@keydown.enter="set_name"
			>
			<button @click="set_name"> Set </button>
		</span>
		<span id="inner" v-else>
			<p
				style="margin: 0 10px 0 0; flex: 1; text-align: right; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
			>
				{{ this.$store.state.player_name }}
			</p>
			<button @click="edit_name"> Edit </button>
		</span>
	</div>
</template>

<style scoped>
#content {
	width: 100%;
	box-sizing: border-box;
	padding: 4px;
	font-size: 20px;
	box-shadow: 0px 0px 5px var(--shadow_color);
	z-index: 10000;
}

#content * {
	font-size: 20px;
}

#inner {
	display: flex;
	vertical-align: middle;
	justify-content: flex-end;
}
</style>

<script lang="ts">
import Vue from 'vue'
export default Vue.extend({
	methods: {
		set_name: function() {
			this.setting = false;
			if (this.new_name != "" && this.new_name.length < 100) {
				var obj = [
					"change_name",
					{
						new_name: this.new_name
					}
				];
				this.$store.state.connection.send(JSON.stringify(obj));
				this.$store.commit("set_player_name", this.new_name);
			}
			this.new_name = "";
		},
		edit_name: function() {
			this.setting = true;
			this.new_name = this.$store.state.player_name;
		}
	},
	data() {
		return {
			new_name: "",
			setting: false
		}
	}
})
</script>
